define('app-AddressLookup/viewModel',['./settings', '../app/ui/dialog', 'knockout', 'underscore'], function (settings, dialog, ko, _) {
    ko.bindingHandlers.focusOnChange = {
        init: function (element) {
            if ($(element).is(':visible')) {
                $(element).focus();
            }
        },
        update: function (element) {
            if ($(element).is(':visible')) {
                $(element).focus();
            }
        }
    };

    return function () {
        var self = this;

        self.suggestedAddresses = ko.observable([]);
        self.selectedAddress = ko.observable('');
        self.oneLineAddress = ko.observable('');
        self.address1 = ko.observable('');
        self.address2 = ko.observable('');
        self.town = ko.observable('');
        self.county = ko.observable('');
        self.postcode = ko.observable(''),
        self.udprn = ko.observable(''),
        self.uprn = ko.observable('');

        self.manualAddress1 = ko.observable('');
        self.manualAddress2 = ko.observable('');
        self.manualTown = ko.observable('');;
        self.manualCounty = ko.observable('');
        self.manualPostcode = ko.observable('');

        self.searchPostcode = ko.observable('').extend({
            required: { message: 'Postcode is required' },
            deferValidation: true
        });

        self.getAddressText = function (addressSummary) {
            return addressSummary.address;
        };

        self.noAddressMessage = function () {
            dialog.show('Postcode not found', 'We couldn\'t find that postcode in our system.');
        };

        self.noPostCodeMessage = function () {
            dialog.show('Postcode required', 'Please enter postcode.');
        };

        self.formattedAddressFailureMessage = function () {
            dialog.show('We\'ve encountered a problem completing your address', 'Please try searching again or enter your address manually.');
        };

        self.manualDialog = null;

        self.loading = null;

        self.findAddress = function () {
            var postCode = self.searchPostcode();
            if (!postCode) {
                self.noPostCodeMessage();
               return;
            }
            self.loading = dialog.show('Searching addresses...', null, {
                noClose: true,
                modal: true
            });

            $.post(settings.getAddressSummariesUrl, { postCode: postCode }, null)
                .done(function (data) {
                    if (data.length === 0) {
                       self.noAddressMessage();
                        return;
                    }

                    self.suggestedAddresses(data);
                })
                .fail(function () {
                    self.noAddressMessage();
                })
                .always(function () {
                    self.loading.close();
                });
        };

        self.manualAddress = function () {
            var id = self.manualDialog.attr('id');
            var errors = $('#' + id + ' :invalid');

            if (!errors || errors.length === 0) {
                var address = _.reject([
                        self.manualAddress1(),
                        self.manualAddress2(),
                        self.manualTown(),
                        self.manualCounty(),
                        self.manualPostcode()
                    ],
                    function(c) {
                        return !c;
                    }).join(', ');

                self.oneLineAddress(address);
                self.address1(self.manualAddress1());
                self.address2(self.manualAddress2());
                self.town(self.manualTown());
                self.county(self.manualCounty());
                self.postcode(self.manualPostcode());

                self.manualDialog.close();

                AdlAddUpdateItem("postcode", self.postcode);
                $('#Address1').trigger("change");
            } 
        };

        self.cancelAddress = function () {
            self.manualAddress1(self.address1());
            self.manualAddress2(self.address2());
            self.manualTown(self.town());
            self.manualCounty(self.county());
            self.manualPostcode(self.postcode());
            self.manualDialog.close();
        };

        self.populatePostCode = function (pCode) {
            self.postcode(pCode);
        };

        self.populateAddress = ko.computed(function () {
            var address = self.selectedAddress();
            if (!address) {
                return;
            }

            self.loading = dialog.show('Completing address search...', null, {
                noClose: true,
                modal: true
            });

            $.post(settings.getFormattedAddressUrl, { token: address.token }, null)
                .done(function (formattedAddress) {
                    if (!formattedAddress) {
                        self.formattedAddressFailureMessage();
                        return;
                    }

                    self.oneLineAddress(formattedAddress.fullAddress);
                    self.address1(formattedAddress.address1);
                    self.address2(formattedAddress.address2);
                    self.town(formattedAddress.town);
                    self.county(formattedAddress.county);
                    self.postcode(formattedAddress.postcode);
                    self.udprn(formattedAddress.udprn);
                    self.uprn(formattedAddress.uprn);

                    self.manualAddress1(formattedAddress.address1);
                    self.manualAddress2(formattedAddress.address2);
                    self.manualTown(formattedAddress.town);
                    self.manualCounty(formattedAddress.county);
                    self.manualPostcode(formattedAddress.postcode);

                    AdlAddUpdateItem("postcode", formattedAddress.postcode);

                    //Trigger required for GDPR
                    $('#Address1').trigger("change");
                })
                .fail(function () {
                    self.formattedAddressFailureMessage();
                })
                .always(function () {
                    self.loading.close();
                });
            self.suggestedAddresses([]);
        }, this);
    }
});
